import { createRouter, createWebHistory } from "vue-router";

import { useMainStore } from "@/stores/store";

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "main" */ "../views/__template"),
    meta: { auth: false },
    children: [
      {
        path: "",
        component: () =>
          import(/* webpackChunkName: "main" */ "../views/ViewScan"),
      },

      {
        path: "/:catchAll(.*)",
        component: () => import(/* webpackChunkName: "404" */ "../views/404"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const store = useMainStore();

  // public route
  if (!to.meta?.auth) return next();

  // Wait for user data to be loaded if it's currently loading
  if (store.userLoading) {
    // Wait for user loading to complete
    const checkUserLoaded = () => {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (!store.userLoading) {
            clearInterval(interval);
            resolve();
          }
        }, 50);
      });
    };

    await checkUserLoaded();
  }

  // still no user -> login
  if (!store.user) return next("/login");

  // required permission (deepest matched meta wins)
  const required =
    to.meta?.permission ??
    to.matched
      .slice()
      .reverse()
      .find((r) => r.meta?.permission)?.meta.permission;

  if (!required) return next(); // route doesn't need a specific permission

  // user's permission slugs - handle both array of objects and array of strings
  const permissions =
    store.user.permissions || store.user.role?.permissions || [];
  const permSet = new Set(
    permissions.map((p) => String(p.slug ?? p).toLowerCase())
  );
  if (permSet.has(String(required).toLowerCase())) return next();

  return next("/no-access");
});

export default router;
